import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { a11yProps } from "../../../Utils/TabsAllyProps";
import { CustomTabPanel } from "../../../Components/CustomTabPanel";
import { Box, Tab, Tabs } from "@mui/material";
import { ActivitiesInnovationTab } from "./ActivitiesInnovationTab/index";
import { useForm } from "react-hook-form";
import { GeneralInformationFinepModel } from "../../../Models/GeneralInformationFINEPModel";
import { tabsTechnologicalFeatures } from "../../../Static/TabsInTechnologicalFeatures";
import { GetByRegistrationDocumentsIdAPI } from "../../../API/GeneralInformationFinepAPI";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { ICompanyActionForm } from "../../../Interfaces/ICompanyActionFormProps";
import { GetCompanyCharacteristicsByRegistrationIdAPI, GetSectoralAspectsByRegistrationIdAPI } from "../../../API/CompanyActionFinepAPI";
import { CompanyCharacteristicsFinepModel } from "../../../Models/CompanyCharacteristicsFinepModel";
import { SectoralAspectsFinepModel } from "../../../Models/SectoralAspectsFinepModel";
import { InnovationHistoricFinepModel } from "../../../Models/InnovationHistoricFinepModel";
import { GetInnovationByRegistrationDocumentsIdAPI } from "../../../API/InnovationHistoricFinepAPI";
import { InnovationActivityFinepModel } from "../../../Models/InnovationActivityFINEPModel";
import { GetInnovationActivityByRegistrationDocumentsIdAPI } from "../../../API/InnovationActivityFinepAPI";
import { toast } from "react-toastify";
import useLoading from "../../../Hooks/useLoading";
import Loader from "../../../Components/Shared/Loader";
import GeneralInfosTab from "./GeneralInfosTab";
import CardHeader from "../../../antd/components/CardHeader";
import CompanyActionTab from "./CompanyActionTab";
import InnovationHistoricFinep from "./InnovationHistoricFinepTab";
import FinepPercentage from "../../../Components/Shared/FinepPercentage";
import './styles.css';
import { TechnologicalFeaturesFinepContext } from "../../../Contexts/TechnologicalFeaturesFinepContext";
import { TechnologicalFeaturesFinepTabs } from "../../../Static/tabs/TechnologicalFinepTabs";

const TechnologicalFeaturesFinep = () => {
    const { registerId, id } = useParams();
    const { loading, toggleLoading } = useLoading();
    const [tab, setTab] = useState(0);
    const [canValidateFirstTab, setCanValidateFirstTab] = useState<boolean>(false);
    const [canValidateSecondTab, setCanValidateSecondTab] = useState<boolean>(false);
    const [canValidateThirdTab, setCanValidateThirdTab] = useState<boolean>(false);
    const [canValidateFourthTab, setCanValidateFourthTab] = useState<boolean>(false);
    const [qtFilled, setQtFilled] = useState<number>(0);
    // const [qtValidated, setQtValidated] = useState<number>(0);
    const [qtdPerTab, setQtdPerTab] = useState(tabsTechnologicalFeatures);
    const { value, validateValue, validateModel, update, handleChangeTab, handleFillTab, handleValidateTab } = useContext(TechnologicalFeaturesFinepContext);

    const generalInformationForm = useForm<GeneralInformationFinepModel>({
        defaultValues: {
            quantityDoctors: 0,
            quantityGraduates: 0,
            quantityMasters: 0,
            quantityMediumFundamental: 0,
            averageRemunerationAnual: 0,
            isPossibility: false,
            townWhereProd: '',
            valueImportsAnnual: 0,
            registerId: registerId,
            isValid: false,
            id: '',
        }
    });

    const companyActionForm = useForm<ICompanyActionForm>({
        defaultValues: {
            companyCharacteristics: {
                id: "",
                registerId: registerId,
                mainMarketSegment: "",
                isValid: false,
            },
            sectoralAspects: {
                id: "",
                registerId: registerId,
                futureTechnologiesNext3YearsImpact: "",
                technologiesIntroducedLast3YearsImpact: "",
                relativePosition: 0,
                participation: 0,
                isValid: false
            }
        }
    });

    const innovationHistoricForm = useForm<InnovationHistoricFinepModel>({
        defaultValues: {
            id: "",
            registerId: registerId,
            hasProcessIntroCompany: false,
            hasProcessIntroMarketing: false,
            incomePercent: 0,
            mainDifferentials: "",
            operationIncomePercent: 0,
            isValid: false
        }
    });

    const innovationActivityForm = useForm<InnovationActivityFinepModel>({
        defaultValues: {
            id: "",
            registerId: registerId,
            activityPndGlobal: "",
            activityPndLocal: "",
            others: "",
            governmentSupportPrograms: "",
            externalRnDExpenditures: 0,
            hasDepToPndLocal: false,
            hasDepToPndGlobal: false,
            internalRnDExpenditures: 0,
            machineryAndEquipmentExpenditures: 0,
            partnershipsDescription: "",
            pndActivityLastYears: undefined,
            qtAssistantOther: 0,
            qtCompanyPartnerships: 0,
            qtDedicationExclusive: 0,
            qtDedicationPartial: 0,
            qtICTContracts: 0,
            qtResearchersBasic: 0,
            qtResearchersDoctors: 0,
            qtResearchersGraduates: 0,
            qtResearchersMasters: 0,
            qtTechniciansBasic: 0,
            qtTechniciansGraduates: 0,
            totalInnovativeActivityExpenditures: 0,
            totalValueOfCompanyPartnerships: 0,
            totalValueOfICTContracts: 0,
            isValid: false
        }
    });

    const getFilledFirstTabCount = (dataResp: GeneralInformationFinepModel) => {
        var filled = 0;

        if (dataResp.quantityDoctors != 0 || dataResp.quantityGraduates != 0 || dataResp.quantityMasters != 0 || dataResp.quantityMediumFundamental != 0) {
            filled += 1;
        }
        if (dataResp.valueImportsAnnual != 0) {
            filled += 1;
        }
        if (dataResp.averageRemunerationAnual != 0) {
            filled += 1;
        }
        if ((dataResp.id != "" && dataResp.isPossibility == false) || (dataResp.isPossibility == true && dataResp.townWhereProd != "")) {
            filled += 1;
        }

        return filled;
    }

    const getFilledSecondTabCount = (dataComp?: CompanyCharacteristicsFinepModel, dataSec?: SectoralAspectsFinepModel) => {
        var filled = 0;

        if (dataComp) {
            if (dataComp.mainDifference) {
                filled += 1;
            }
            if (dataComp.mainMarketSegment != "") {
                filled += 1;
            }
            if ((dataComp.bestMarketing && dataComp.bestMarketing != 7) || (dataComp.bestMarketing == 7 && dataComp.other != "")) {
                filled += 1;
            }
            if (dataComp.topCustomersFineps && dataComp.topCustomersFineps.length > 0) {
                filled += 1
            }
        }
        if (dataSec) {
            if (dataSec.futureTechnologiesNext3YearsImpact != "") {
                filled += 1;
            }
            if (dataSec.participation != 0) {
                filled += 1;
            }
            if (dataSec.relativePosition != 0) {
                filled += 1;
            }
            if (dataSec.relevanceAvaliation) {
                filled += 1;
            }
            if (dataSec.technologiesIntroducedLast3YearsImpact != "") {
                filled += 1;
            }
            if (dataSec.mainCompaniesFineps && dataSec.mainCompaniesFineps.length > 0) {
                filled += 1
            }
        }

        return filled;
    }

    const getFilledThirdTabCount = (dataResp: InnovationHistoricFinepModel) => {
        var filled = 0;

        if (dataResp.incomePercent > 0 || dataResp.operationIncomePercent > 0) {
            filled += 1;
        }
        if (dataResp.id != "" && dataResp.hasProcessIntroCompany) {
            filled += 1;
        }
        if (dataResp.id != "" && dataResp.hasProcessIntroMarketing) {
            filled += 1;
        }
        if (dataResp.mainDifferentials != "") {
            filled += 1;
        }

        return filled;
    }

    const getFilledFourthTabCount = (dataResp: InnovationActivityFinepModel) => {
        var filled = 0;

        if (dataResp.pndActivityLastYears != undefined && dataResp.pndActivityLastYears?.toString() != "") {
            filled += 1;
        }
        if (dataResp.qtResearchersDoctors > 0 ||
            dataResp.qtResearchersGraduates > 0 ||
            dataResp.qtResearchersMasters > 0 ||
            dataResp.qtResearchersBasic > 0 ||
            dataResp.qtTechniciansGraduates > 0 ||
            dataResp.qtTechniciansBasic > 0 ||
            dataResp.qtAssistantOther > 0
        ) {
            filled += 1;
        }
        if (dataResp.qtDedicationExclusive > 0 ||
            dataResp.qtDedicationPartial > 0
        ) {
            filled += 1;
        }
        if (dataResp.hasDepToPndLocal == false || (dataResp.hasDepToPndLocal == true && dataResp.activityPndLocal != "")) {
            filled += 1;
        }
        if (dataResp.hasDepToPndGlobal == false || (dataResp.hasDepToPndGlobal == true && dataResp.activityPndGlobal != "")) {
            filled += 1;
        }
        if (dataResp.qtICTContracts > 0) {
            filled += 1;
        }
        if (dataResp.totalValueOfICTContracts > 0) {
            filled += 1;
        }
        if (dataResp.qtCompanyPartnerships > 0) {
            filled += 1;
        }
        if (dataResp.totalValueOfCompanyPartnerships > 0) {
            filled += 1;
        }
        if (dataResp.partnershipsDescription != "") {
            filled += 1;
        }
        if (dataResp.internalRnDExpenditures > 0) {
            filled += 1;
        }
        if (dataResp.externalRnDExpenditures > 0) {
            filled += 1;
        }
        if (dataResp.machineryAndEquipmentExpenditures > 0) {
            filled += 1;
        }
        if (dataResp.totalInnovativeActivityExpenditures > 0) {
            filled += 1;
        }
        if (dataResp.governmentSupportPrograms != "" &&
            (!dataResp.governmentSupportPrograms.includes("others") ||
                dataResp.governmentSupportPrograms.includes("others") && dataResp.others != "")
        ) {
            filled += 1;
        }

        return filled;
    }

    const getGeneralInfosTab = async () => {
        try {
            toggleLoading(true);

            await GetByRegistrationDocumentsIdAPI(registerId!).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var data = resp.data as GeneralInformationFinepModel | null;

                    if (data != null) {
                        generalInformationForm.reset(data);

                        handleFillTab(0)

                        var filled = getFilledFirstTabCount(data);

                        (filled == 4)
                            ? setCanValidateFirstTab(true)
                            : setCanValidateFirstTab(false);

                        calculatePercentage(canValidateFirstTab, 'generalInformation', filled);
                    }
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const getCompanyActionTab = async () => {
        try {
            toggleLoading(true);

            var respComp = await GetCompanyCharacteristicsByRegistrationIdAPI(registerId!);
            var respSec = await GetSectoralAspectsByRegistrationIdAPI(registerId!);

            var dataComp = respComp.data as CompanyCharacteristicsFinepModel | null;
            var dataSec = respSec.data as SectoralAspectsFinepModel | null;

            companyActionForm.reset(formValues => ({
                sectoralAspects: dataSec != null ? dataSec : formValues.sectoralAspects,
                companyCharacteristics: dataComp != null ? dataComp : formValues.companyCharacteristics
            }));

            var isValid = (dataComp?.isValid && dataSec?.isValid) ?? false;
            var filled = 0;

            if (dataComp != null) {
                filled += getFilledSecondTabCount(dataComp);

                calculatePercentage(isValid, 'companyPerformance', filled);
            }
            if (dataSec != null) {
                filled += getFilledSecondTabCount(undefined, dataSec);

                calculatePercentage(isValid, 'companyPerformance', filled);
            }

            if (filled == 10) {
                setCanValidateSecondTab(true);
            } else {
                setCanValidateSecondTab(false);
            }
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const getInnovationHistoricTab = async () => {
        try {
            toggleLoading(true);

            await GetInnovationByRegistrationDocumentsIdAPI(registerId ?? "").then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var data = resp.data as InnovationHistoricFinepModel | null;

                    if (data != null) {
                        innovationHistoricForm.reset(data);

                        var filled = getFilledThirdTabCount(data);

                        calculatePercentage(data.isValid, 'innovationHistoric', filled);

                        if (filled == 4) {
                            setCanValidateThirdTab(true);
                        } else {
                            setCanValidateThirdTab(false);
                        }
                    }
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const getInnovationActivityTab = async () => {
        try {
            toggleLoading(true);

            await GetInnovationActivityByRegistrationDocumentsIdAPI(registerId ?? "").then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var data = resp.data as InnovationActivityFinepModel | null;

                    if (data != null) {
                        innovationActivityForm.reset(data);

                        var filled = getFilledFourthTabCount(data);

                        calculatePercentage(data.isValid, 'innovationActivity', filled);

                        if (filled == 15) {
                            setCanValidateFourthTab(true);
                        } else {
                            setCanValidateFourthTab(false);
                        }
                    }
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const calculatePercentage = (isValidated: boolean, tabName: string, qtdFilled: number) => {

        var totalFields = qtdPerTab.reduce((accumulator, tab) => {
            return accumulator + tab.qtd;
        }, 0); //100%

        const newQtdPerTab = qtdPerTab.map(tab => {
            if (tab.label == tabName) {
                tab.isValidated = isValidated;
                tab.qtdToFill = isValidated ? 0 : tab.qtd - qtdFilled;
            }

            return tab;
        }); //set true or false to tab validate

        setQtdPerTab(newQtdPerTab);

        // var qtdValidated = newQtdPerTab.reduce((accumulator, tab) => {
        //     if (tab.isValidated) {
        //         return accumulator + tab.qtd;
        //     } else {
        //         return accumulator + 0;
        //     }
        // }, 0);

        var qtdFilled = newQtdPerTab.reduce((accumulator, tab) => {
            if (tab.isValidated) {
                return accumulator + tab.qtd;
            } else {
                return accumulator + tab.qtd - tab.qtdToFill;
            }
        }, 0);

        // var validatedPorcentage = Math.floor((qtdValidated * 100) / totalFields); //% validated
        var filledPorcentage = Math.floor((qtdFilled * 100) / totalFields); //% filled

        // setQtValidated(validatedPorcentage);
        setQtFilled(filledPorcentage);
    }

    useEffect(() => {
        if (registerId != undefined && registerId != "") {
            getGeneralInfosTab();
            getCompanyActionTab();
            getInnovationHistoricTab();
            getInnovationActivityTab();
        }
    }, [registerId]);

    const filleds = validateModel.reduce((acc, obj) => acc + obj.filledsPercentage, 0);
    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <CardHeader
                pageName="Finep Reembolsável - Caracteristicas Tecnologicas"
                hasPageBefore={true}
                pageBeforeName="Cadastro Finep"
                linkPageBefore={`/registrationFinep/${registerId}/${id}`}
            />
            <div className='card-body p-4'>
                <FinepPercentage filled={Math.floor(filleds)} validated={Math.floor(validateValue)} />
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example" style={{ textTransform: "none"}}>
                        {TechnologicalFeaturesFinepTabs.map((tab, index) => {
                            return (<Tab key={index} label={tab.label} {...tab.props} />)
                        })}
                    </Tabs>
                </Box>
                <div>
                    <CustomTabPanel value={value} index={0}>
                        <GeneralInfosTab
                            generalInformationForm={generalInformationForm}
                            calculatePercentage={calculatePercentage}
                            getFilledFirstTabCount={getFilledFirstTabCount}
                            canValidateFirstTab={canValidateFirstTab}
                            setCanValidateFirstTab={setCanValidateFirstTab}
                        />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <CompanyActionTab
                            companyActionForm={companyActionForm}
                            calculatePercentage={calculatePercentage}
                            getFilledSecondTabCount={getFilledSecondTabCount}
                            canValidateSecondTab={canValidateSecondTab}
                            setCanValidateSecondTab={setCanValidateSecondTab}
                        />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <InnovationHistoricFinep
                            innovationHistoricForm={innovationHistoricForm}
                            getFilledThirdTabCount={getFilledThirdTabCount}
                            calculatePercentage={calculatePercentage}
                            canValidateThirdTab={canValidateThirdTab}
                            setCanValidateThirdTab={setCanValidateThirdTab}
                        />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                        <ActivitiesInnovationTab
                            innovationActivityForm={innovationActivityForm}
                            getFilledFourthTabCount={getFilledFourthTabCount}
                            calculatePercentage={calculatePercentage}
                            canValidateFourthTab={canValidateFourthTab}
                            setCanValidateFourthTab={setCanValidateFourthTab}
                        />
                    </CustomTabPanel>
                </div>
            </div>
        </div>
    );
}

export default TechnologicalFeaturesFinep;